import { render, staticRenderFns } from "./StatisticExtractRequest.vue?vue&type=template&id=06db40fa&"
import script from "./StatisticExtractRequest.vue?vue&type=script&lang=js&"
export * from "./StatisticExtractRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports